export default __webpack_public_path__ + "media/images/logo_text-336b6f38d2a12bd04c62a9bd9c30c765.png";